import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Styles from './Tabs.module.scss';

export default class Tab extends React.PureComponent {
  render() {
    return (
      <div
        className={cx(Styles.tab, { [Styles.active]: this.props.isActive })}
        onClick={this.props.onClick}
      >
        {this.props.children}
      </div>
    );
  }
}

Tab.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  component: PropTypes.element,
  validateTabChange: PropTypes.func
};
